module.exports = __webpack_public_path__ + "static/media/brazil-icon.b9cd90ce.svg";